import React from 'react';
import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
 const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "100%", bgcolor: "#ffffff", }} data-model-id="548:1002">
            <Container maxWidth="lg" sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "38px", maxWidth: "500px", textAlign: "center", }}>
                    <Box>
                        <Typography variant="h1" sx={{ fontFamily: "Poppins, Helvetica", fontWeight: 700, fontSize: "3.75rem", mb: 2, color: "#4B49AC", }} >
                            Oops!
                        </Typography>
                        <Typography variant="body1" sx={{ fontFamily: "Poppins, Helvetica", fontWeight: 500, color: "#4B49AC", fontSize: "1.125rem", }} >
                            The page you're looking for doesn't exist.
                        </Typography>
                    </Box>
                    <Box component="img" src="/image/errorImage.gif" alt="404 Error Illustration" sx={{ width: "100%", height: "auto", maxHeight: "500px", objectFit: "cover", }} />

                    <Button variant="contained"
                            sx={{ bgcolor: "#4B49AC", borderRadius: 1, fontFamily: "Poppins, Helvetica",
                            fontWeight: 500, fontSize: "15px", padding: "10px 20px", width: "250px", height: "50px", textTransform: "none",
                            }} onClick={handleGoBack}> Back To Home
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};

export default NotFound;